import { defineComponent as _defineComponent } from 'vue'
import { VignetteRoutes } from "@/types";
import { useSessionStore } from "@/pinia/session";
import { useAppStore } from "@/pinia/app";
import { useRouter } from "vue-router/composables";
import { computed, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ApplicationHeader',
  setup(__props) {

const router = useRouter();

const sessionStore = useSessionStore();
const appStore = useAppStore();
const navDrawerExpanded = ref(false);

const hasVignetteAccess = computed(
  () => sessionStore.hasVignetteAccess ?? false
);

const isLoggedIn = computed(() => sessionStore.isLoggedIn);
const pageTitle = computed(() => appStore.pageName + " - Almanac+");
const djangoSiteOrigin = computed(() => appStore.djangoSiteOrigin);

const currentDate = () => {
  return new Date()
    .toLocaleDateString("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    })
    .toUpperCase();
};

const facebookUrl = computed(() => {
  return `https://www.facebook.com/NationalJournal/?ref=page_internal`;
});

const twitterUrl = computed(() => {
  return `https://twitter.com/nationaljournal`;
});

const linkedInUrl = computed(() => {
  return `https://www.linkedin.com/company/9313`;
});

const navigateToMyAccountPage = (): void => {
  router.push({ name: VignetteRoutes.MyAccount });
};

return { __sfc: true,router, sessionStore, appStore, navDrawerExpanded, hasVignetteAccess, isLoggedIn, pageTitle, djangoSiteOrigin, currentDate, facebookUrl, twitterUrl, linkedInUrl, navigateToMyAccountPage, VignetteRoutes }
}

})